import classNames from 'classnames';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getExtraCallData } from '../../api';
import { acceptCallbackKeyPress, deleteCallback, deleteCallbackKeyPress, playCallbackKeyPress, resetCallback } from '../../api/call-control';
import { useSelector } from '../../hook-utils';
import { AlertIconType, showAlertDialog, showConfirmWindow } from '../../legacy';
import { Media, SERVER_DATE_FOMATE } from '../../model';
import { actions } from '../../store';
import { getActiveDevice } from '../../store/reducers';
import { selectDateFormating, selectMyDevices, selectMyRegion, selectRescheduleWrapupDuration } from '../../store/reducers/config';
import { selecMediaExtraData } from '../../store/reducers/media';
import Button from '../Button';
import { callClidDescription, CallControl } from '../CallPopup';
import DateTimePicker from '../DateTimePicker';
import { ReactComponent as DeleteIcon } from '../icons/delete.svg';
import { ReactComponent as PlayIcon } from '../icons/play.svg';
import { ReactComponent as RescheduleIcon } from '../icons/queue/reset.svg';
import { ReactComponent as AcceptIcon } from '../icons/tick.svg';
import ProfilePhoto from '../ProfilePhoto';
import './CallView.scss';

export function CallView({ media }: { media: Media }) {
  const region = useSelector(selectMyRegion)
  const extraData = useSelector(s => selecMediaExtraData(s, media.id))
  const dispatch = useDispatch()
  const clid = callClidDescription(media, region)

  useEffect(() => {
    if(extraData) return
    let mounted = true;
    load()
    return () => { mounted = false }

    async function load() {
      const data = await getExtraCallData(media.clidObjectType, media.clidObjectKey, media.clid, media.clidDescription)
      if (!mounted) { return }
      dispatch(actions.updateMediaExtraData(media.id, data))
    }

  }, [dispatch, extraData, media.clid, media.clidDescription, media.clidObjectKey, media.clidObjectType, media.id])

  return <div className='CallView'>
    <CallControl className='call-control' call={media} />
    <div className='caller-details'>
      <ProfilePhoto className='caller-pic' name={media.clidDescription} clid={media.clid} load={media.clidObjectKey !== ""}/>
      <table>
        <tbody>
          <tr>
            <th>Customer Name</th>
            <td>{extraData && (extraData.name === '' ? 'Unknown' : extraData.name)}</td>
          </tr>
          <tr>
            <td>Company</td>
            <td>{extraData && extraData.company}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td>{extraData && extraData.email !== "" && extraData.email} </td>
          </tr>
          <tr>
            <td>Caller</td>
            <td>{clid}</td>
          </tr>
          <tr>
            <td>Business</td>
            <td>{extraData && extraData.phone}</td>
          </tr>
          <tr>
            <td>Mobile</td>
            <td>{extraData && extraData.mobile}</td>
          </tr>
          <tr>
            <td>Home</td>
            <td>{extraData && extraData.home}</td>
          </tr>
          <tr>
            <td>Department</td>
            <td>{extraData && extraData.department}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div className='caller-details-bottom'>
      {media.clidObjectKey === '' && <Button primary onClick={() => dispatch(actions.openAgentView(media.id, 'contact'))}>
        Add / Link Contact
      </Button>}
    </div>

    {media && media.mediaType === "VM" && <CallbackControl media={media} />}
  </div>
}

function CallbackControl({ media }: { media: Media }) {
  const dispatch = useDispatch()
  const [date, setDate] = useState(0)
  const format = useSelector(selectDateFormating)
  const rescheduleWrapupDuration = useSelector(selectRescheduleWrapupDuration)
  const devices = useSelector(selectMyDevices)
  const device = devices && getActiveDevice(media, devices.devices, devices.primaryDevice)

  if (!date) {
    let t = dayjs().add(rescheduleWrapupDuration != null ? rescheduleWrapupDuration : 0, 'minute')
    if (t.minute() < 15) {
      t = t.add(15 - t.minute(), 'minute')
    } else if (t.minute() < 30) {
      t = t.add(30 - t.minute(), 'minute')
    } else if (t.minute() < 45) {
      t = t.add(45 - t.minute(), 'minute')
    } else if (t.minute() > 45) {
      t = t.add(60 - t.minute(), 'minute')
    }

    setDate(t.valueOf())
  }

  if (!format || !device) return null

  return <div className='CallbackControl'>
    <div title='Play Callback voicemail message' className={classNames(media.voicemailPort === '' && 'disabled')} ><PlayIcon onClick={(e => {

      if (media.voicemailPort !== '') {
        playCallbackKeyPress(device.number, media.voicemailPort)
      } else {
        showAlertDialog('Play Callback', 'Accepting a Callback is only valid during message playback.', AlertIconType.Info)
      }

    })} /></div>
    <div title='Accept Callback' className={classNames(media.voicemailPort === '' && 'disabled')} ><AcceptIcon onClick={(e => {

      if (media.voicemailPort !== '') {
        acceptCallbackKeyPress(device.number, media.voicemailPort)
      } else {
        showAlertDialog('Play Callback', 'Accepting a Callback is only valid during message playback.', AlertIconType.Info)
      }

    })} /></div>
    <div title='Delete Callback' className={classNames(media.voicemailPort === '' && 'disabled')} ><DeleteIcon onClick={(e => {

      showConfirmWindow('Delete Callback', 'Are you sure you want to delete this Callback?', (action: string) => {
        if (action === "yes" && device) {
          if (media.voicemailPort !== '') {
            deleteCallbackKeyPress(device.number, media.voicemailPort)
          } else {
            deleteCallback(device.number, media.id)
          }
        }
      })

    })} /></div>
    <div title='Reschedule Callback' className={classNames(media.voicemailPort === '' && 'disabled')} ><RescheduleIcon onClick={(async e => {

      if (date) {
        await resetCallback(media.id, dayjs(date).utc().format(SERVER_DATE_FOMATE))
        dispatch(actions.ccHangUp(device.number, media))
      }

    })} /></div>
    <DateTimePicker value={date} onChange={setDate} disabled={media.voicemailPort === ''} />
  </div>
}
